module.exports = __webpack_public_path__ + "static/media/feature.5d95dbf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HarleyDykstra/feature.jpg
// module id = 262
// module chunks = 0